<template></template>

<script>
import { authen } from '@/api/auth';
import {
  getCampaignId,
  getCodeVerifier,
  removeCampaignId,
  removeCodeVerifier,
  setCampaignId,
  setCodeVerifier
} from '@/utils/campaign';
import { setErrorMessage } from "@/utils/error";
import { getUserAgentMobile } from "@/utils/auth";
import Raven from "raven-js";

export default {
  name: "Authen",
  beforeRouteEnter(to, from, next) {

    let info = {
      'campaignId': to.query.id,
      'userAgentMobile': getUserAgentMobile(),
    };
    authen(info)
      .then((data) => {

        // console.log('param:'+JSON.stringify(data.result.param));
        if (data.result.param) {
          // console.log(getCodeVerifier());
          if (getCodeVerifier()) {
            removeCodeVerifier();
          }
          setCodeVerifier(data.result.param);
          Raven.setExtraContext({
            codeVerifier: data.result.param
          });
          Raven.captureMessage("authen/setCodeVerifier", {
            tags: { category: "test" },
            level: "info",
          });
        }

        // set campaign id to cookies
        let campaignId = to.query.id;

        if (campaignId) {
          if (getCampaignId()) {
            removeCampaignId();
          }
          setCampaignId(campaignId);
        } else {
          Raven.setExtraContext({
            url: data.result.url.split("&")[4],
            userAgentMobile: info.userAgentMobile,
          });
          Raven.captureMessage("authen/campaignId not found", {
            tags: { category: "test" },
            level: "error",
          });
          next('/not-found');
        }

        try {
          // console.log(JSON.stringify(data));

          let queryStr = JSON.stringify(data.result.url);
          let queries = {};
          queryStr.split('&').forEach(function (queryStr) {
            let queryArr = queryStr.split('=');
            queries[queryArr[0]] = queryArr[1];
          });

          window.location.href = data.result.url;
        } catch (err) {
          Raven.setExtraContext({
            campaignId: info.campaignId,
            userAgentMobile: info.userAgentMobile,
          });
          Raven.captureMessage("authen/url error", {
            tags: { category: "test" },
            level: "error",
          });
          console.log(err)
        }
      })

      .catch(error => {
        if (error.response && error.response.status) {
          setErrorMessage(error.response.status);
        }
        Raven.setExtraContext({
          campaignId: info.campaignId,
          userAgentMobile: info.userAgentMobile,
        });
        Raven.captureMessage("authen/authen api error", {
          tags: { category: "test" },
          level: "error",
        });
        next('/error');
      });
  },
}
</script>
